import React from 'react'
import _ from 'underscore'
import Checkbox from 'components/Checkbox'

import FormSection from 'pages/shared/FormSection'

type Props = {
  selectedTiers: Array<string>,
  onChangeCallback: (attributes: { tiers: Array<string> }) => void,
  errors?: { tiers?: string } | null,
}

const tierDisplayName: Record<string, string> = {
  standard: 'Standard',
  premium: 'Premium',
  trial: 'Trial'
}

const TierFields = ({ selectedTiers, onChangeCallback, errors }: Props) => {
  const allTiers: Array<string> = ['standard', 'premium', 'trial']

  const onTierChange = (tier: string) => {
    const updatedTiers = _.contains(selectedTiers, tier)
      ? _.without(selectedTiers, tier)
      : _.union(selectedTiers, [tier])

    onChangeCallback({ tiers: updatedTiers })
  }

  return (
    <FormSection title="Tiers">
      {
        allTiers.map((tier) => (
          <Checkbox
            key={tier}
            label={tierDisplayName[tier]}
            checked={selectedTiers.includes(tier)}
            onChange={() => onTierChange(tier)}
            errorMessage={_.last(allTiers) === tier ? errors?.tiers : undefined}
          />
        ))
      }
    </FormSection>
  )
}

export default TierFields
